import { render, staticRenderFns } from "./PromocaoHotel.vue?vue&type=template&id=14cc9e54&"
import script from "./PromocaoHotel.vue?vue&type=script&lang=js&"
export * from "./PromocaoHotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports